"use client"
import { useLanguage } from "../../contexts/LanguageContext";

export default function FiltersModal({ isOpen, onClose, filters, setFilters }) {
  const { t } = useLanguage();
  if (!isOpen) return null;

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFilters((prevFilters) => ({ ...prevFilters, [name]: value }));
    };

    const inputStyle = {
      width: '100%', padding: '10px 14px', background: 'var(--input-bg)', border: '1px solid var(--input-border)',
      borderRadius: '10px', color: 'var(--text-primary)', fontSize: '0.85rem', outline: 'none', marginTop: '4px',
    };

    return (
      <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', backdropFilter: 'blur(6px)', display: 'flex', alignItems: 'flex-start', justifyContent: 'center', paddingTop: '80px', zIndex: 50 }}>
        <div style={{ background: 'var(--bg-card)', border: '1px solid var(--border-glass)', borderRadius: '20px', padding: '28px', width: '380px', maxWidth: '90vw', position: 'relative' }}>
          <div style={{ height: '3px', position: 'absolute', top: 0, left: 0, right: 0, borderRadius: '20px 20px 0 0', background: 'linear-gradient(90deg, var(--accent-cyan), var(--accent-violet))' }} />
          <div style={{ textAlign: 'center', marginTop: '8px' }}>
            <h3 style={{ fontSize: '1.1rem', fontWeight: 700, color: 'var(--text-primary)', fontFamily: 'var(--font-display)', marginBottom: '16px' }}>{t('filterProjects')}</h3>
            <form style={{ textAlign: 'left' }}>
              <div style={{ marginBottom: '14px' }}>
                <label style={{ fontSize: '0.8rem', fontWeight: 600, color: 'var(--text-secondary)' }}>{t('fromDate')}</label>
                <input type="date" name="fromDate" value={filters.fromDate || ""} onChange={handleInputChange} style={inputStyle} />
              </div>
              <div style={{ marginBottom: '14px' }}>
                <label style={{ fontSize: '0.8rem', fontWeight: 600, color: 'var(--text-secondary)' }}>{t('toDate')}</label>
                <input type="date" name="toDate" value={filters.toDate || ""} onChange={handleInputChange} style={inputStyle} />
              </div>
              <div style={{ marginBottom: '14px' }}>
                <label style={{ fontSize: '0.8rem', fontWeight: 600, color: 'var(--text-secondary)' }}>{t('status')}</label>
                <select name="status" value={filters.status || ""} onChange={handleInputChange} style={{ ...inputStyle, cursor: 'pointer' }}>
                  <option value="">{t('all')}</option>
                  <option value="unassigned">{t('unassigned')}</option>
                  <option value="assigned">{t('assigned')}</option>
                  <option value="completed">{t('completed')}</option>
                  <option value="private">{t('private')}</option>
                </select>
              </div>
            </form>
            <button onClick={onClose} style={{ width: '100%', padding: '12px', borderRadius: '12px', border: 'none', background: 'linear-gradient(135deg, var(--accent-cyan), var(--accent-violet))', color: '#fff', fontWeight: 600, cursor: 'pointer', fontSize: '0.85rem' }}>{t('close')}</button>
          </div>
        </div>
      </div>
    );
}

